import { render } from "./PreCAL.vue?vue&type=template&id=d89edfda&scoped=true"
import script from "./PreCAL.vue?vue&type=script&lang=js"
export * from "./PreCAL.vue?vue&type=script&lang=js"

import "./PreCAL.vue?vue&type=style&index=0&id=d89edfda&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d89edfda"

export default script